<template>
  <div class="stran-brez-izbirnika pregled-vsebine">
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine" v-loading="nalaganjeVsebine">
        <div>
          <p class="open-sans-30pt">
            Družabna omrežja
          </p>
        </div>
        <div style="padding-top: 30px">
          <p class="navadno-besedilo">
            Za enostavnejši vpis v Moj T-2 in ostale T-2 aplikacije, povežite
            svoj uporabniški račun z vašim Facebook, Google ali Apple računom.
            <span v-if="this.prikazTabele === '1'">
              <br/>
            </span>
            Elektronskega naslova tako ne bo več potrebno vpisovati.
          </p>
        </div>
        <div class="postavitev-druzbenih-omrezij">
          <div class="container">
            <div>
              <div class="postavitev-ikone">
                <img src="/static/img/MojProfil/Druzabno/logo_googleg_48dp.png" alt="Google">
              </div>
              <div style="padding-top: 20px" v-if="googleId === null">
                  <el-button class="gumb-potrdi" @click="FollowLink(googlePovezava)">
                    POVEŽI Z GOOGLE
                  </el-button>
              </div>
              <div style="padding-top: 20px" v-else>
                <el-button class="gumb-potrjeno disabled">
                  <img src="/static/img/kljukica2.svg" class="tick-style"/>
                  PRIJAVA AKTIVNA
                </el-button>
              </div>
            </div>
            <div class="odmik-povezav">
              <div class="postavitev-ikone">
                <img src="/static/img/MojProfil/Druzabno/iconmonstr-facebook-6.png" alt="Facebook">
              </div>
              <div style="padding-top: 20px" v-if="fbId === null">
                  <el-button class="gumb-potrdi" @click="FollowLink(facebookPovezava)">
                    POVEŽI S FACEBOOK
                  </el-button>
              </div>
              <div style="padding-top: 20px" v-else>
                <el-button class="gumb-potrjeno disabled">
                  <img src="/static/img/kljukica2.svg" class="tick-style"/>
                  PRIJAVA AKTIVNA
                </el-button>
              </div>
            </div>
            <div class="odmik-povezav odmik-apple-id">
              <div class="postavitev-ikone">
                <img src="/static/img/MojProfil/Druzabno/png-apple-logo-9708.png"
                     alt="Apple" style="height: 60px; width: 60px;">
              </div>
              <div style="padding-top: 20px" v-if="appleId === null">
                <el-button class="gumb-potrdi" @click="FollowLink(appleIdPovezava)">
                  POVEŽI Z APPLE ID
                </el-button>
              </div>
              <div style="padding-top: 20px" v-else>
                <el-button class="gumb-potrjeno disabled">
                  <img src="/static/img/kljukica2.svg" class="tick-style"/>
                  PRIJAVA AKTIVNA
                </el-button>
              </div>
            </div>
          </div>
          <div class="postavitev-info">
            <div class="info-okvir">
              <div class="postavitev-info-icone">
                <i class="fa fa-info-circle"></i>
              </div>
              <div class="postavitev-info-tekst">
                <p class="modra-barva-info navadno-besedilo">
                  S povezavo družabnega omrežja s Moj T-2 boste lahko enostavno in hitro
                  dostopali do vašega računa v Moj T-2. Dovolj bo le klik na gumb »prijava«,
                  brez ponovnega vpisa uporabniških podatkov.<br/><br/>
                  Prekinitev povezave z družabnim omrežjem lahko uredite kadarkoli v nastavitvah
                  družabnega omrežja – povezane aplikacije.
                  <span class="postavitev-vsebine-info-box">
                    Opozorilo: Prijavo z družabnimi omrežji
                    <b>
                      svetujemo le na vaših osebnih računalnikih.
                    </b>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div style="clear: both"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {configSSO} from '../../../../assets/js/config.js'
import {Button, Select, Alert, MessageBox} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'

export default {
  name: 'Druzabno',
  mixins: [PrikazVsebine],
  data () {
    return {
      clientAgent: null,
      facebookPovezava: '',
      googlePovezava: '',
      nalaganjeVsebine: false,
      fbId: null,
      googleId: null,
      appleId: null,
      mejnaSirinaTabela: 1000,
      prikazTabele: '0',
      appleIdPovezava: ''
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
      window.dispatchEvent(new Event('resize'))
    })
    this.GetUserData()
    this.InitPovezave()
    if (typeof this.$route.query.napaka !== 'undefined') {
      this.ShowErrorMessage({ 'message': this.$route.query.napaka })
    }
  },
  components: {
    [Button.name]: Button,
    [Select.name]: Select,
    [Alert.name]: Alert,
    [MessageBox.name]: MessageBox
  },
  methods: {
    InitPovezave () {
      let redirectUrl = new URL(configSSO.AUTH0_CALLBACK_URL)
      let baseUrl = 'https://' + configSSO.AUTH0_DOMAIN + '/?'
      baseUrl += 'redirect_uri=' + redirectUrl.origin + '/Mojprofil/Druzabno'
      this.googlePovezava = baseUrl + '&googleLogin=1'
      this.facebookPovezava = baseUrl + '&fbLogin=1'
      this.appleIdPovezava = baseUrl + '&appleLogin=1'
    },
    FollowLink (povezava) {
      this.clientAgent.t2Auth.deleteTokens()
      window.location = povezava
    },
    GetUserData () {
      this.nalaganjeVsebine = true
      let param = []
      this.clientAgent.postWsRequest(
        this,
        'user/info?',
        param,
        null,
        'SetUserData',
        'ErrSporocilo')
    },
    SetUserData (podatki) {
      this.googleId = podatki.googleId
      this.fbId = podatki.fbId
      this.appleId = podatki.appleId
      this.nalaganjeVsebine = false
    }
    // PrekinitevFB () {
    //   MessageBox.confirm('Ali ste prepričani, da želite prekiniti povezavo s Facebookom?', {
    //     confirmButtonText: 'Da',
    //     cancelButtonText: 'Prekliči',
    //     confirmButtonClass: 'gumb-potrdi',
    //     cancelButtonClass: 'gumb-preklici',
    //     customClass: 'opozorilo-dialog'
    //   }).then(() => {
    //     this.nalaganjeVsebine = true
    //     let param = []
    //     this.clientAgent.postWsRequest(
    //       this,
    //       'user/prekiniFbPovezavo?',
    //       param,
    //       null,
    //       'SetPrekinitevFB',
    //       'ErrSporocilo')
    //   }).catch((err) => {
    //     err = null
    //   })
    // },
    // SetPrekinitevFB () {
    //   let paramObvestilo = {}
    //   paramObvestilo.message = 'Vašo povezavo s Facebook računom smo prekinili. Račun lahko kadarkoli ponovno' +
    //     ' povežete.'
    //   this.ShowSuccessMessage(paramObvestilo)
    //   this.GetUserData()
    //   this.nalaganjeVsebine = false
    // },
    // PrekinitevGoogle () {
    //   MessageBox.confirm('Ali ste prepričani, da želite prekiniti povezavo z Googlom?',
    //     {
    //       confirmButtonText: 'Da',
    //       cancelButtonText: 'Prekliči',
    //       confirmButtonClass: 'gumb-potrdi',
    //       cancelButtonClass: 'gumb-preklici',
    //       customClass: 'opozorilo-dialog'
    //     }).then(() => {
    //     this.nalaganjeVsebine = true
    //     let param = []
    //     this.clientAgent.postWsRequest(
    //       this,
    //       'user/prekiniGooglePovezavo?',
    //       param,
    //       null,
    //       'SetPrekinitevGoogle',
    //       'ErrSporocilo')
    //   }).catch((err) => {
    //     err = null
    //   })
    // },
    // SetPrekinitevGoogle () {
    //   let paramObvestilo = {}
    //   paramObvestilo.message = 'Vašo povezavo s Google računom smo prekinili. Račun' +
    //     ' lahko kadarkoli ponovno povežete.'
    //   this.ShowSuccessMessage(paramObvestilo)
    //   this.GetUserData()
    //   this.nalaganjeVsebine = false
    // },
    // ErrSporocilo (podatki) {
    //   let paramObvestilo = {}
    //   paramObvestilo.message = podatki.message
    //   this.ShowErrorMessage(paramObvestilo)
    //   this.nalaganjeVsebine = false
    // },
    // PrekinitevAppleId () {
    //   MessageBox.confirm('Ali ste prepričani, da želite prekiniti povezavo z Apple ID?',
    //     {
    //       confirmButtonText: 'Da',
    //       cancelButtonText: 'Prekliči',
    //       confirmButtonClass: 'gumb-potrdi',
    //       cancelButtonClass: 'gumb-preklici',
    //       customClass: 'opozorilo-dialog'
    //     }).then(() => {
    //     this.nalaganjeVsebine = true
    //     let param = []
    //     this.clientAgent.postWsRequest(
    //       this,
    //       'user/prekiniApplePovezavo?',
    //       param,
    //       null,
    //       'SetPrekinitevAppleId',
    //       'ErrSporocilo')
    //   }).catch((err) => {
    //     err = null
    //   })
    // },
    // SetPrekinitevAppleId () {
    //   let paramObvestilo = {}
    //   paramObvestilo.message = 'Vašo povezavo z Apple ID računom smo prekinili. Račun' +
    //     ' lahko kadarkoli ponovno povežete.'
    //   this.ShowSuccessMessage(paramObvestilo)
    //   this.GetUserData()
    //   this.nalaganjeVsebine = false
    // }
  }
}
</script>
<style scoped src="../../../../../static/css/moj_profil/druzabno.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Druzabno.vue